import React, { useState, useEffect } from 'react'
import styles from './managementConsoleWidgets.module.scss'
import { Col, Row } from 'react-bootstrap'
import { MANAGEMENT_CONSOLE_WIDGET } from '../../../../../Utils/GlobalConstants';
import { api } from '../../../../../Utils/API';

const ManagementConsoleWidgets = (props) => {

  const [managementConsoleWidget, setManagementConsoleWidget] = useState(null);
  // Header Authorization for General API's
  const config = {
    headers: {
      "Authorization": `${localStorage.getItem("token_type")} ${localStorage.getItem("access_token")}`,
    },
  };


  // Function to call all Customer count data
  async function GetManagementConsoleWidget() {
    await api.get(`${MANAGEMENT_CONSOLE_WIDGET}?requestedResellerCode=${props.requestedResellerCode}`, config)
      .then(resp => {
        setManagementConsoleWidget(resp.data);
      })
      .catch(error => {
        if (error?.status == 401 || error?.response?.status == 401) {
          props.Logout();
        }
        else {
        }
      });
  };

  useEffect(() => {
    GetManagementConsoleWidget();
  }, [])

  useEffect(() => {
    if(props.requestedResellerCode != null && props.requestedResellerCode != "")
    GetManagementConsoleWidget()
  }, [props.requestedResellerCode])

  return (
    <Row className='my-3'>
      {managementConsoleWidget && managementConsoleWidget.map((widget) => {
        if(widget.widgetTitle==="Active Subscriptions"){
            return(
          // <Col lg={2} md={5} xs={5} className={`${styles["widget-body"]} px-3 mx-2 mr-4`}>
          <Col lg={2} md={3} xs={5} className={`${styles["widget-body"]} ${styles["widget-wrapper"]} ${props.activeWidget === widget.widgetTitle ? styles["widget-body-highlighted"] : ""} ${styles["widget-clickable"]} px-3 mx-2 mr-4`} onClick={()=>{props.setActiveWidget(widget.widgetTitle);props.setActiveWidgetFlag(true);}}>
          
            <span>{widget.widgetTitle}</span>
            <h3 className={widget.widgetTitle === "Active Subscriptions" ? styles["widget-body-green"] : (widget.widgetTitle === "Active Trial Subscriptions" ? styles["widget-body-default"] : (widget.widgetTitle === "Expiring Subscriptions" ? styles["widget-body-yellow"] : styles["widget-body-green"]))}>{`${Intl.NumberFormat("en-US", { minimumFractionDigits: 0 }).format((parseInt(widget.count)).toFixed(2))}`}</h3>
            {props.activeWidget === widget.widgetTitle && (
              <div className={styles["success-bubble"]}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.5 4.5L6 12L2.5 8.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
            )}
          </Col>
        )}
        else {
          return (
            <Col lg={2} md={3} xs={5} className={`${styles["widget-body"]} ${styles["widget-wrapper"]} ${props.activeWidget === widget.widgetTitle ? styles["widget-body-highlighted"] : ""} ${styles["widget-clickable"]} px-3 mx-2 mr-4`} onClick={() => { props.setActiveWidget(widget.widgetTitle); props.setActiveWidgetFlag(true) }}>
              <span>{widget.widgetTitle}</span>
               <h3 className={widget.widgetTitle === "Active Subscriptions" ? styles["widget-body-green"] : (widget.widgetTitle === "Active Trial Subscriptions" ? styles["widget-body-default"] : (widget.widgetTitle === "Expiring Subscriptions" ? styles["widget-body-yellow"] : styles["widget-body-green"]))}>{`${Intl.NumberFormat("en-US", { minimumFractionDigits: 0 }).format((parseInt(widget.count)).toFixed(2))}`}</h3>

              {props.activeWidget === widget.widgetTitle && (
                <div className={styles["success-bubble"]}>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.5 4.5L6 12L2.5 8.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
              )}
            </Col>
          )
        }
      })
      }
    </Row>
  )
}

export default ManagementConsoleWidgets
